<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div
        class="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-15"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      >
        <!--begin: Aside Container -->
        <div class="d-flex flex-row-fluid flex-column justify-content-between">
          <!--begin: Aside header -->
          <!-- <a href="#" class="flex-column-auto">
            <img :src="siteLogo" class="h-25" />
          </a> -->
          <!--end: Aside header -->
          <!--begin: Aside content -->
          <div
            class="flex-column-fluid d-flex flex-column justify-content-center"
          >
            <h3 class="font-size-h1 mt-10 mb-5 text-white opal-font">
              {{ $t("AUTH.GENERAL.WELCOME") }}
            </h3>
            <p class="font-weight-lighter text-white opacity-80">
              {{ $t("AUTH.GENERAL.WELCOME_DESCRIPTION") }}
            </p>
          </div>
          <!--end: Aside content -->
          <!--begin: Aside footer for desktop -->
          <div
            class="d-none flex-column-auto d-lg-flex justify-content-between mt-15"
          >
            <div class="opacity-70 font-weight-bold text-white opal-font">
              © {{ new Date().getFullYear() }}
              {{ $t("AUTH.GENERAL.FOOTER_LEFT") }}
            </div>
            <!-- <div class="d-flex">
              <a href="#" class="text-white">Privacy</a>
              <a href="#" class="text-white ml-10">Legal</a>
              <a href="#" class="text-white ml-10">Contact</a>
            </div> -->
          </div>
          <!--end: Aside footer for desktop -->
        </div>
        <!--end: Aside Container -->
      </div>
      <!--begin::Aside-->

      <!--begin::Content-->
      <div
        class="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden"
      >
        <div
          class="d-flex flex-column-fluid flex-center"
          :class="isDriverDashboard ? 'mt-0' : 'mt-30 mt-lg-0'"
        >
          <router-view></router-view>
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  methods: {},
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    siteLogo() {
      return process.env.BASE_URL + "media/logos/logo-letter-1.png";
    },
    isDriverDashboard() {
      return this.$route.name === "driver-machine";
    },
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/lyunik-2.jpg";
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/custom.scss";
</style>
